// @flow
import React from "react";
import { localize } from "redux-i18n";
import { compose } from "redux";
import { GSGrid, GSRenderers } from "@components";
import type { GSGridColumn } from "@components/gs-grid";
import * as clientsSelectors from "@modules/client/selectors";
import { connect } from "react-redux";

export type SLAChartRecord = {
  month: string,
  totalInboundInteractions: number,
  totalAutoCallbacks: number,
  totalAsapCallbacks: number,
  totalScheduledCallbacks: number,
  totalInteractionsHandled: number,
  totalAbsencesClosed: number,
  absencesClosedByTextToClose: number,
  closedByTextToClosePercentage: string,
  asapCallbacksInSla: number,
  asapCallbacksSlaPercentage: string,
  scheduledCallbacksInSla: number,
  scheduledCallbacksSlaPercentage: string,
  totalSmsNotifications: number,
  totalEmailNotifications: number,
  notificationsSlaPercentage: string,
  totalManagerLogins: number,
  totalUniqueManagers: number,
};
export type SLAReportRecord = {
  id: string,
  name: string,
  periods: [
    {
      key: string,
      value: number,
      type: string,
    },
  ],
};

type PropsFromDispatch = $Exact<{
  data: SLAReportRecord[],
  charts: [],
  isLoading: boolean,
}>;
type PropsFromState = $Exact<{
  isLoading: boolean,
}>;

type Props = $Exact<{
  ...PropsFromDispatch,
}>;

export class SlaReportDetailsGrid extends React.Component<Props> {
  getPeriodWithHighestValue = (data: SLAReportRecord[]) => {
    let maxValue = -Infinity;

    data.forEach(item => {
      item.periods.forEach(period => {
        if (period.key !== "Period Total") {
          const value = parseFloat(period.value);
          if (value > maxValue) {
            maxValue = value;
          }
        }
      });
    });

    return maxValue;
  };
  generateColumns = (data: SLAChartRecord[]): GSGridColumn[] => {
    return data
      .map((chrtRecord: SLAChartRecord): GSGridColumn => {
        return {
          name: chrtRecord.month,
          key: chrtRecord.month,
          minWidth: 110,
          renderCell: ({ row, column }: *) => {
            const val = row.periods.filter(period => {
              return period.key === column.name;
            });
            return <div>{val[0].value}</div>;
          },
        };
      })
      .filter((column: GSGridColumn) => column.name !== "Period Total");
  };

  render() {
    const maxPeriod = this.getPeriodWithHighestValue(this.props.data);
    const rowData = this.props.data.filter(d => d.name !== "month");
    return (
      <div className="w-100">
        {rowData.length < 1 ||
        this.props.charts.length < 1 ||
        this.props.data.length < 1 ||
        this.props.isLoading ? (
          <div className={"center-aligned-text"}>
            <h3>{this.props.t("NO_DATA_PLEASE_APPLY_FILTERS")}</h3>
          </div>
        ) : (
          <GSGrid
            columns={[
              {
                name: this.props.t("MEASURE"),
                key: "name",
                align: "left",
                // width: "max-content",

                frozen: "left",
              },
              ...this.generateColumns(this.props.charts),
              {
                name: this.props.t("PERIOD_TOTAL"),
                key: "period",
                frozen: "right",
                width: 100,
                cellClass: "p-1px",
                renderCell: ({ row }: *) => {
                  const val = row.periods.filter(period => {
                    return period.key === "Period Total";
                  });
                  const res = {
                    total: val[0].value,
                    max: maxPeriod,
                  };
                  return GSRenderers.barIndicator(res);
                },
              },
              {
                name: "Trend",
                key: "trend",
                frozen: "right",
                width: 100,
                cellClass: "p-1px",
                renderCell: ({ row }: *) => {
                  const periods = row.periods.filter(period => {
                    return period.key !== "Period Total";
                  });
                  return GSRenderers.sparklineIndicator({ rowHeight: 40, periods: periods });
                },
              },
            ]}
            rows={rowData}
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state: Object): PropsFromState => {
  return {
    isLoading: clientsSelectors.getSlaPerformanceRequestsInProgress(state),
  };
};

export default compose(connect(mapStateToProps), localize())(SlaReportDetailsGrid);
